import { useEffect, useRef, useState } from 'react';
import '../../assets/css/common/table.css';
import '../../assets/css/common/common.css';
import { useDispatch, useSelector } from 'react-redux';
import ImageModal from '../common/ImageModal';
import { setSort } from '../../redux/actions/common';
import { clearErrors } from '../../redux/actions/error';
import { setNbpbkbn, setProhibitedItem } from '../../redux/actions/modal';
import { checkEnableSelect, checkPble } from '../../utils/helpers/common';
import { useTranslation } from 'react-i18next';
import { renderRowValue } from '../../utils/helpers/table';

const SelectTable = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {
        heads,
        body,
        dataTable = [],
        isSelectRow,
        isMultiSelectRow,
        onSelectRow,
        selectedRows,
        isAllowValidate,
        isSelectExcel,
        isChange,
        page,
    } = props;

    const storage = useSelector((state) => state.storage);
    const { isCompetitor, isInstruction, isHead } = storage;

    const tableWrapperRef = useRef();

    const [showModal, setShowModal] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [isCheckAllFirst, setIsCheckAllFirst] = useState(false);

    const sort = useSelector((state) => state.sort);

    useEffect(() => {
        checkCheckAll(dataTable);
    }, [isChange, page]);

    const isSubset = (selectableItem, items) => {
        const itemJans = new Set(items.map((item) => item.jan));
        return selectableItem?.every((item) => itemJans.has(item.jan));
    };

    const checkCheckAll = (dataTable) => {
        const selectableItem = isHead
            ? dataTable
            : dataTable
                  ?.filter((item) => !checkPble(item.pbleFlag, item.exception))
                  ?.filter((item) => !(item.prohibited && item.lowerLimit === null));
        const isSelected = isSubset(selectableItem, selectedRows);

        if (isSelected) {
            setIsCheckAllFirst(true);
        } else {
            setIsCheckAllFirst(false);
        }
    };

    const handleOpenModal = (imageUrl) => {
        if (imageUrl) {
            setImageUrl(imageUrl);
            setShowModal(true);
        }
    };
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSelectRow = (isSelectRow, index, record) => {
        if (!isSelectRow || !checkEnableSelect(isCompetitor, record, selectedRows, isMultiSelectRow)) {
            return;
        }
        onSelectRow(index, record);
    };

    const toggleCheckboxAll = (setIsCheckAll, value) => {
        const rowsJanSet = new Set(selectedRows.map((item) => item.jan));
        const newDataTable = isHead
            ? dataTable?.filter((item) => (value ? !rowsJanSet.has(item.jan) : rowsJanSet.has(item.jan)))
            : dataTable
                  ?.filter((item) => !checkPble(item.pbleFlag, item.exception))
                  ?.filter((item) => !(item.prohibited && item.lowerLimit === null))
                  ?.filter((item) => (value ? !rowsJanSet.has(item.jan) : rowsJanSet.has(item.jan)));
        newDataTable.map((item, index) => {
            handleSelectRow(isSelectRow, index, item);
        });
        setIsCheckAll(value);
    };

    const renderHeads = () => {
        const headLength = heads?.filter((head) => head && !head.disabled).length;
        return (
            <>
                {isSelectExcel && (
                    // Excelの場合
                    <tr>
                        <th className="invisible column" colSpan={headLength - 1}></th>
                        <th className="checkbox freeze-column freeze-right-0" style={{ padding: '0px' }}>
                            <button
                                className={`btn price-request__all ${isCheckAllFirst ? 'btn--secondary' : 'btn--primary'}`}
                                onClick={() =>
                                    isCheckAllFirst
                                        ? toggleCheckboxAll(setIsCheckAllFirst, false)
                                        : toggleCheckboxAll(setIsCheckAllFirst, true)
                                }
                            >
                                {isCheckAllFirst ? t('button.release_all') : t('button.check_all')}
                            </button>
                        </th>
                    </tr>
                )}
                <tr className="text-center okc-table-title">
                    <th className="column" colSpan={headLength}>
                        検索一覧
                    </th>
                </tr>
                <tr>
                    {heads?.map((head, index) => {
                        if (Object.keys(head).length === 0 || head.disabled) {
                            return <></>;
                        }

                        return (
                            <th
                                key={index}
                                colSpan={head.colSpan}
                                className={`v-select-default ${head.field ? 'sort' : ''} ${sort.sortField === head.field && sort.sortType === 'DESC' ? 'active' : ''} ${head.className}`}
                                onClick={() => {
                                    if (!head.field) {
                                        return;
                                    }
                                    const sortType = sort.sortField === head.field ? (sort.sortType === 'ASC' ? 'DESC' : 'ASC') : 'DESC';
                                    dispatch(
                                        setSort({
                                            sortField: head.field,
                                            sortType: sortType,
                                        }),
                                    );
                                }}
                            >
                                <>{head?.title}</>
                            </th>
                        );
                    })}
                </tr>
            </>
        );
    };

    const checkSelectedRow = (jan) => {
        let isSelectedRow = false;
        if (!selectedRows || selectedRows.length === 0) {
            return false;
        }
        selectedRows.forEach((itemRow) => {
            if (itemRow.jan === jan) {
                isSelectedRow = true;
            }
        });
        return isSelectedRow;
    };

    const handleError = (itemRow) => {
        dispatch(clearErrors());
        dispatch(
            setProhibitedItem({
                isShow: true,
                items: [itemRow],
            }),
        );
    };

    const handlePbleError = (itemRow) => {
        dispatch(clearErrors());
        dispatch(
            setNbpbkbn({
                isShow: true,
                items: [itemRow],
            }),
        );
    };

    const renderRows = () => {
        const headLength = heads?.filter((head) => head && !head.disabled).length;
        return (
            <>
                {dataTable?.length > 0 ? (
                    <>
                        {dataTable?.map((itemRow, indexRow) => (
                            <tr
                                key={indexRow}
                                className={`${isSelectRow ? 'v-select-row' : 'v-select-default'} ${
                                    isSelectRow && checkSelectedRow(itemRow.jan) ? 'selectable active' : ''
                                } ${checkEnableSelect(isCompetitor, itemRow, selectedRows, isMultiSelectRow) ? '' : 'unselectable'} ${!(isInstruction && isAllowValidate) && itemRow.prohibited && itemRow.lowerLimit === null ? 'v-back-gray' : ''}`}
                                onClick={() => {
                                    isCompetitor && checkPble(itemRow.pbleFlag, itemRow.exception)
                                        ? handlePbleError(itemRow)
                                        : !(isInstruction && isAllowValidate) && itemRow.prohibited
                                          ? itemRow.lowerLimit !== null
                                              ? handleSelectRow(isSelectRow, indexRow, itemRow)
                                              : handleError(itemRow)
                                          : handleSelectRow(isSelectRow, indexRow, itemRow);
                                }}
                            >
                                {body?.columns
                                    ?.filter((item) => !!item)
                                    .map((itemColumn, indexColumn) => {
                                        if (Object.keys(itemColumn).length === 0) {
                                            return <td key={indexColumn}></td>;
                                        }
                                        return (
                                            <td key={indexColumn} className={`${itemColumn?.className ?? ''}`}>
                                                {itemColumn?.isLink && itemRow?.imageUrl ? (
                                                    <span
                                                        className="text-underline"
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            event.preventDefault();
                                                            handleOpenModal(itemRow?.imageUrl);
                                                        }}
                                                    >
                                                        ●
                                                    </span>
                                                ) : (
                                                    <span>{renderRowValue(t, itemColumn, itemRow)}</span>
                                                )}
                                            </td>
                                        );
                                    })}
                            </tr>
                        ))}
                    </>
                ) : (
                    <>
                        <div class="no-result-overlay">{'該当商品が見つかりません。'}</div>
                        <div className="hover-overlay"></div>
                        <tr className="no-result">
                            {headLength && <td colSpan={headLength - 1} className="no-result-left"></td>}
                            <td className="no-result-right freeze-right-0"></td>
                        </tr>
                    </>
                )}
            </>
        );
    };

    return (
        <div>
            <ImageModal show={showModal} handleClose={handleCloseModal} imageUrl={imageUrl} />
            <div ref={tableWrapperRef} className={`okc-table components__table-wrapper bases__padding--bottom20`}>
                <div className="table-responsive">
                    <table className="w-100">
                        <thead>{renderHeads()}</thead>
                        <tbody className="okc-table__wrapper">{renderRows()}</tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default SelectTable;
